<template>
  <a-breadcrumb class="dol-breadcrumb" >
    <a-breadcrumb-item v-if="!hideSystemMenu" v-for="item in curMenu" :key="item._id">
      <router-link :to="item.link">{{item.name}}</router-link>
    </a-breadcrumb-item>
    <a-breadcrumb-item  v-for="(appendItem,index) in appendMenu" :key="index" >
      <router-link :to="appendItem.link">{{appendItem.name}}</router-link>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
  export default {
    name: "dol-breadcrumb",
    props:{
      appendMenu:{type: Array},
      hideSystemMenu:{type: Boolean, default: false},
    },
    data(){
      return {
        curMenu:null,
      };
    },
    watch:{
      $route(){
        this.getCurMenu();
      },
    },
    methods:{
      getCurMenu(){
        let curLink = this.$route.fullPath;
        let curMenu = [];
        let findMenu = (data, level) => {
          data.forEach(menu => {
            if(new RegExp('^' + menu.link + '/').test(curLink)
              || new RegExp('^' + menu.link + '$').test(curLink)
              || new RegExp('^' + menu.link + '\\?').test(curLink)
            ){
              curMenu[level] = menu;
              if(!menu.isLeaf){
                findMenu(menu.children, level + 1);
              }
            }
          });
        };

        if(this.$store.state.userInfo){
          findMenu((this.$store.state.userInfo.menu && this.$store.state.userInfo.menu.rows) || [], 0);
        }

        this.curMenu = curMenu;
      }
    },
    created() {
      this.getCurMenu();
    }
  }
</script>

<style lang="scss" scoped>
.dol-breadcrumb{
  margin: 10px 0;
}
</style>
